// extracted by mini-css-extract-plugin
module.exports = {"surveyHeader":"styles_surveyHeader__L3p2w"};